import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { db } from "../firebase/config";
import { collection, addDoc } from "firebase/firestore";
import { auth } from "../firebase/config";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { createContext, useContext } from "react";

import { useState, useEffect } from "react";
import { onAuthStateChanged, getAuth } from "firebase/auth"; // Import necessary Firebase methods

export const useAuth = () => {
  const [currentUser, setCurrentUser] = useState(null); // State to store the user

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user); // Set the user when the auth state changes
    });

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  return { currentUser }; // Return current user state
};

export const login = async (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const register = async (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

//get references of collections named 'students'
const accountsCollectionRef = collection(db, "users");

 export const signup = async (
  firstName,
  lastName,
  email,
  password,
  role,
  num,
  department,
) => {
  const resp = await firebase
    .auth()
    .createUserWithEmailAndPassword(email, password);
  await resp.user.updateProfile({ displayName: `${firstName} ${lastName}` });
  const name = [firstName, lastName];
  if (role.includes("Faculty")) {
    var userId = resp.user.uid;
    addDoc(accountsCollectionRef, {
      id: userId,
      name: name.join(" "),
      role: role,
      isVerified: false,
      email: email,
      num: num,
      department: department,
    });
  } else {
    var userId = resp.user.uid;
    addDoc(accountsCollectionRef, {
      id: userId,
      name: name.join(" "),
      role: role,
      email: email,
    });
  }
};

export const logout = () => {
  return firebase.auth().signOut();
};

export const passwordReset = async (email) => {
  return await firebase.auth().sendPasswordResetEmail(email);
};

{/*export const login = async (email, password) => {
  const resp = await firebase
    .auth()
    .signInWithEmailAndPassword(email, password);
  return resp.user;
}; */}

// import firebase from "firebase/compat/app";
// import "firebase/compat/auth";
// import { db } from "../firebase/config";
// import { collection, addDoc } from "firebase/firestore";
// import { auth } from "../firebase/config";
// import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, sendPasswordResetEmail } from "firebase/auth";
// import { useState, useEffect, createContext, useContext } from "react";
// import { onAuthStateChanged, getAuth } from "firebase/auth";

// // Context for Authentication
// const AuthContext = createContext();

// // Custom Hook for Auth State
// export const useAuth = () => {
//   return useContext(AuthContext);
// };

// // Auth Provider Component (Wrap your App in this)
// export const AuthProvider = ({ children }) => {
//   const [currentUser, setCurrentUser] = useState(null);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, setCurrentUser);
//     return unsubscribe; // Cleanup on unmount
//   }, []);

//   return <AuthContext.Provider value={{ currentUser }}>{children}</AuthContext.Provider>;
// };

// // Login Function
// export const login = async (email, password) => {
//   return signInWithEmailAndPassword(auth, email, password);
// };

// // Register / Signup Function
// export const signup = async (firstName, lastName, email, password, role, num = null, department = null) => {
//   const resp = await createUserWithEmailAndPassword(auth, email, password);
//   await resp.user.updateProfile({ displayName: `${firstName} ${lastName}` });

//   const userId = resp.user.uid;
//   const userData = {
//     id: userId,
//     name: `${firstName} ${lastName}`,
//     role,
//     email,
//     isVerified: false
//   };

//   // Add optional fields based on role
//   if (role === "instructor") {
//     userData.num = num;
//     userData.department = department;
//   }

//   return addDoc(collection(db, "users"), userData);
// };

// // Logout Function
// export const logout = () => {
//   return signOut(auth);
// };

// // Password Reset Function
// export const passwordReset = async (email) => {
//   return sendPasswordResetEmail(auth, email);
// };
